<div class="bookings-section" [@fadeInFadeOut]="disableAnimation ? null : counter" role="main" aria-label="Booking process">
  @if (showStripeRedirectionLoader) {
    <div class="d-flex flex-column justify-content-center align-items-center py-5" role="status" aria-live="polite" [attr.aria-label]="'stripe_redirect.processing_title' | translate">
      <div class="spinner-border text-primary mb-3" role="status" aria-hidden="true">
        <span class="visually-hidden">{{ 'stripe_redirect.loading' | translate }}</span>
      </div>
      <div class="text-center">
        <p class="mb-0">{{ 'stripe_redirect.processing_title' | translate }}</p>
        <p class="text-muted small">{{ 'stripe_redirect.processing_subtitle' | translate }}</p>
      </div>
    </div>
  }
  @if (showAdyenPaymentReceived) {
    <!-- The payment tab itself, sent back here without its opener: the booking is finished in the tab that started it. -->
    <div class="alert alert-info my-3 cbsw-adyen-payment-received" role="status" aria-live="polite">
      {{ adyenPaymentReceivedKey | translate }}
    </div>
  }
  @if (this.widgetTemplates?.length && !showStripeRedirectionLoader && !showAdyenPaymentReceived) {
    <div
      id="{{ bookingPageViews.BOOKING_QUESTIONS_VIEW_BEFORE }}"
      class="cbsw-booking-questions-view-before"
      role="region"
      [attr.aria-label]="'Booking questions'"
      [attr.aria-hidden]="selectedViewPrecedence > showOnePageUiUpToViewPrecedence && selectedViewPrecedence !== sectionPrecedence[bookingPageViews.BOOKING_QUESTIONS_VIEW_BEFORE]"
      [ngClass]="{
        'cbsw-not-allow-edit': !allowEditActivePage(bookingPageViews.BOOKING_QUESTIONS_VIEW_BEFORE),
        'cbsw-hide-section': selectedViewPrecedence > showOnePageUiUpToViewPrecedence && selectedViewPrecedence !== sectionPrecedence[bookingPageViews.BOOKING_QUESTIONS_VIEW_BEFORE],
        'cbsw-active-section': selectedView === bookingPageViews.BOOKING_QUESTIONS_VIEW_BEFORE,
      }"
    >
      @if (
        (selectedView === bookingPageViews.BOOKING_QUESTIONS_VIEW_BEFORE || showOnePageUI(bookingPageViews.BOOKING_QUESTIONS_VIEW_BEFORE)) &&
        bookingService.isBeforeQuestionsMode()
      ) {
        <app-booking-questions-view
          customClass="cbsw-booking-questions-step-before"
          [isBeforeQuestionsStep]="true"
          [isFirstBookingQuestionActive]="isFirstBeforeBookingQuestionActive"
          [isLastBookingQuestionActive]="isLastBeforeBookingQuestionActive"
          (nextPageEvent)="increment(); isFirstBeforeBookingQuestionActive = false; isLastBeforeBookingQuestionActive = true; gotoView($event); bookingService.lastView = bookingPageViews.BOOKING_QUESTIONS_VIEW_BEFORE"
          role="form"
          aria-label="Initial booking questions"
        />
      }
    </div>

    <div
      id="{{ bookingPageViews.MEETING_TYPE_VIEW }}"
      class="cbsw-meeting-type-view"
      role="region"
      [attr.aria-label]="'Meeting type selection'"
      [attr.aria-hidden]="(selectedViewPrecedence > showOnePageUiUpToViewPrecedence && selectedViewPrecedence !== sectionPrecedence[bookingPageViews.MEETING_TYPE_VIEW]) || isHiddenStepSuppressed(bookingPageViews.MEETING_TYPE_VIEW)"
      [ngClass]="{
        'cbsw-not-allow-edit': !allowEditActivePage(bookingPageViews.MEETING_TYPE_VIEW),
        'cbsw-hide-section': (selectedViewPrecedence > showOnePageUiUpToViewPrecedence && selectedViewPrecedence !== sectionPrecedence[bookingPageViews.MEETING_TYPE_VIEW]) || isHiddenStepSuppressed(bookingPageViews.MEETING_TYPE_VIEW),
        'cbsw-active-section': selectedView === bookingPageViews.MEETING_TYPE_VIEW,
      }"
    >
      @if (
        (selectedView === bookingPageViews.MEETING_TYPE_VIEW || showOnePageUI(bookingPageViews.MEETING_TYPE_VIEW)) &&
        bookingService.isMeetingTypeStepInFlow()
      ) {
        <app-meeting-type-selection
          (gotoPage)="increment(); gotoView($event); bookingService.lastView = bookingPageViews.MEETING_TYPE_VIEW"
          (previousPageEvent)="decrement(); gotoView($event); bookingService.lastView = bookingPageViews.MEETING_TYPE_VIEW"
          role="form"
          aria-label="Select meeting type"
        />
      }
    </div>

    <div
      id="{{ bookingPageViews.STORE_VIEW }}"
      class="cbsw-store-view"
      role="region"
      [attr.aria-label]="'Store selection'"
      [attr.aria-hidden]="(selectedViewPrecedence > showOnePageUiUpToViewPrecedence && selectedViewPrecedence !== sectionPrecedence[bookingPageViews.STORE_VIEW]) || isHiddenStepSuppressed(bookingPageViews.STORE_VIEW)"
      [ngClass]="{
        'cbsw-not-allow-edit': !allowEditActivePage(bookingPageViews.STORE_VIEW),
        'cbsw-hide-section': (selectedViewPrecedence > showOnePageUiUpToViewPrecedence && selectedViewPrecedence !== sectionPrecedence[bookingPageViews.STORE_VIEW]) || isHiddenStepSuppressed(bookingPageViews.STORE_VIEW),
        'cbsw-active-section': selectedView === bookingPageViews.STORE_VIEW,
      }"
    >
      @if (
        (selectedView === bookingPageViews.STORE_VIEW || showOnePageUI(bookingPageViews.STORE_VIEW)) &&
        (
          !bookingService.isMeetingTypeStepInFlow() ||
          (
            bookingService.isMeetingTypeStepInFlow() &&
            (
              bookingService?.selectedBookingData?.currentSelectedAppointmentState?.selectedMeetingTypeId === meetingTypeId.STORE ||
              bookingService?.selectedBookingData?.currentSelectedAppointmentState?.selectedMeetingTypeId === meetingTypeId.CUSTOMER
            )
          )
        )
      ) {
        <app-store-selection
          (gotoPage)="increment(); gotoView($event); bookingService.lastView = bookingPageViews.STORE_VIEW"
          (previousPageEvent)="decrement(); gotoView($event); bookingService.lastView = bookingPageViews.STORE_VIEW"
          role="form"
          aria-label="Select store location"
        />
      }
    </div>

    <div
      id="{{ bookingPageViews.SERVICES_VIEW }}"
      class="cbsw-service-view"
      role="region"
      [attr.aria-label]="'Service selection'"
      [attr.aria-hidden]="(selectedViewPrecedence > showOnePageUiUpToViewPrecedence && selectedViewPrecedence !== sectionPrecedence[bookingPageViews.SERVICES_VIEW]) || isHiddenStepSuppressed(bookingPageViews.SERVICES_VIEW)"
      [ngClass]="{
        'cbsw-not-allow-edit': !allowEditActivePage(bookingPageViews.SERVICES_VIEW),
        'cbsw-hide-section': (selectedViewPrecedence > showOnePageUiUpToViewPrecedence && selectedViewPrecedence !== sectionPrecedence[bookingPageViews.SERVICES_VIEW]) || isHiddenStepSuppressed(bookingPageViews.SERVICES_VIEW),
        'cbsw-active-section': selectedView === bookingPageViews.SERVICES_VIEW
      }"
    >
      @if (selectedView === bookingPageViews.SERVICES_VIEW || showOnePageUI(bookingPageViews.SERVICES_VIEW)) {
        <app-services-selection
          (nextPageEvent)="increment(); gotoView($event); bookingService.lastView = bookingPageViews.SERVICES_VIEW"
          (previousPageEvent)="decrement(); gotoView($event); bookingService.lastView = bookingPageViews.SERVICES_VIEW"
          role="form"
          aria-label="Select services"
        />
      }
    </div>
    <div
      id="{{ bookingPageViews.WORKERS_VIEW }}"
      class="cbsw-workers-view"
      role="region"
      [attr.aria-label]="'Worker selection'"
      [attr.aria-hidden]="(selectedViewPrecedence > showOnePageUiUpToViewPrecedence && selectedViewPrecedence !== sectionPrecedence[bookingPageViews.WORKERS_VIEW]) || isHiddenStepSuppressed(bookingPageViews.WORKERS_VIEW)"
      [ngClass]="{
        'cbsw-not-allow-edit': !allowEditActivePage(bookingPageViews.WORKERS_VIEW),
        'cbsw-hide-section': (selectedViewPrecedence > showOnePageUiUpToViewPrecedence && selectedViewPrecedence !== sectionPrecedence[bookingPageViews.WORKERS_VIEW]) || isHiddenStepSuppressed(bookingPageViews.WORKERS_VIEW),
        'cbsw-active-section': selectedView === bookingPageViews.WORKERS_VIEW
      }"
    >
      @if (selectedView === bookingPageViews.WORKERS_VIEW || showOnePageUI(bookingPageViews.WORKERS_VIEW)) {
        <app-workers-selection
          (nextPageEvent)="increment(); gotoView($event); bookingService.lastView = bookingPageViews.WORKERS_VIEW"
          (previousPageEvent)="decrement(); gotoView($event); bookingService.lastView = bookingPageViews.WORKERS_VIEW"
          role="form"
          aria-label="Select worker"
        />
      }
    </div>

    <div
      id="{{ bookingPageViews.SLOTS_VIEW }}"
      class="cbsw-slots-view"
      role="region"
      [attr.aria-label]="'Time slot selection'"
      [attr.aria-hidden]="selectedViewPrecedence > showOnePageUiUpToViewPrecedence && selectedViewPrecedence !== sectionPrecedence[bookingPageViews.SLOTS_VIEW]"
      [ngClass]="{
        'cbsw-not-allow-edit': !allowEditActivePage(bookingPageViews.SLOTS_VIEW),
        'cbsw-hide-section': selectedViewPrecedence > showOnePageUiUpToViewPrecedence && selectedViewPrecedence !== sectionPrecedence[bookingPageViews.SLOTS_VIEW],
        'cbsw-active-section': selectedView === bookingPageViews.SLOTS_VIEW
      }"
    >
      @if (selectedView === bookingPageViews.SLOTS_VIEW || showOnePageUI(bookingPageViews.SLOTS_VIEW)) {
        <app-slots-selection
          [timezones]="timezones"
          (onTimezoneChange)="onTimezoneChangeEvent($event)"
          (nextPageEvent)="increment(); gotoView($event); bookingService.lastView = bookingPageViews.SLOTS_VIEW"
          (previousPageEvent)="decrement(); gotoView($event); bookingService.lastView = bookingPageViews.SLOTS_VIEW"
          role="form"
          aria-label="Select available time slot"
        />
      }
    </div>

    <div
      id="{{ bookingPageViews.BOOKING_QUESTIONS_VIEW_AFTER }}"
      class="cbsw-booking-questions-view-after"
      role="region"
      [attr.aria-label]="'Additional booking questions'"
      [attr.aria-hidden]="selectedViewPrecedence > showOnePageUiUpToViewPrecedence && selectedViewPrecedence !== sectionPrecedence[bookingPageViews.BOOKING_QUESTIONS_VIEW_AFTER]"
      [ngClass]="{
        'cbsw-not-allow-edit': !allowEditActivePage(bookingPageViews.BOOKING_QUESTIONS_VIEW_AFTER),
        'cbsw-hide-section': selectedViewPrecedence > showOnePageUiUpToViewPrecedence && selectedViewPrecedence !== sectionPrecedence[bookingPageViews.BOOKING_QUESTIONS_VIEW_AFTER],
        'cbsw-active-section': selectedView === bookingPageViews.BOOKING_QUESTIONS_VIEW_AFTER
      }"
    >
      @if (
        (selectedView === bookingPageViews.BOOKING_QUESTIONS_VIEW_AFTER || showOnePageUI(bookingPageViews.BOOKING_QUESTIONS_VIEW_AFTER)) &&
        showAfterQuestionsView()
      ) {
        <app-booking-questions-view
          customClass="cbsw-booking-questions-step-after"
          [isFirstBookingQuestionActive]="isFirstBookingQuestionActive"
          [isLastBookingQuestionActive]="isLastBookingQuestionActive"
          (nextPageEvent)="increment(); isFirstBookingQuestionActive = false; isLastBookingQuestionActive = true; gotoView($event)"
          (previousPageEvent)="decrement(); isFirstBookingQuestionActive = true; isLastBookingQuestionActive = false; gotoView($event)"
          role="form"
          aria-label="Additional booking questions"
        />
      }
    </div>

    <div
      id="{{ bookingPageViews.PERSONAL_FORM_VIEW }}"
      class="cbsw-personal-form-view"
      role="region"
      [attr.aria-label]="'Personal information form'"
      [attr.aria-hidden]="selectedViewPrecedence > showOnePageUiUpToViewPrecedence && selectedViewPrecedence !== sectionPrecedence[bookingPageViews.PERSONAL_FORM_VIEW]"
      [ngClass]="{
        'cbsw-not-allow-edit': !allowEditActivePage(bookingPageViews.PERSONAL_FORM_VIEW),
        'cbsw-hide-section': selectedViewPrecedence > showOnePageUiUpToViewPrecedence && selectedViewPrecedence !== sectionPrecedence[bookingPageViews.PERSONAL_FORM_VIEW],
        'cbsw-active-section': selectedView === bookingPageViews.PERSONAL_FORM_VIEW
      }"
    >
      @if (selectedView === bookingPageViews.PERSONAL_FORM_VIEW || showOnePageUI(bookingPageViews.PERSONAL_FORM_VIEW)) {
        <app-personal-form-view
          (nextPageEvent)="increment(); gotoView($event)"
          (previousPageEvent)="decrement(); isFirstBookingQuestionActive = false; isLastBookingQuestionActive = true; gotoView($event);"
          [partnerData]="bookingService?.partnerData"
          role="form"
          aria-label="Enter personal information"
        />
      }
    </div>

    <div
      id="{{ bookingPageViews.BOOKING_SUMMARY_VIEW }}"
      class="cbsw-booking-summary-view"
      role="region"
      [attr.aria-label]="'Booking summary'"
      [attr.aria-hidden]="selectedViewPrecedence > showOnePageUiUpToViewPrecedence && selectedViewPrecedence !== sectionPrecedence[bookingPageViews.BOOKING_SUMMARY_VIEW]"
      [ngClass]="{
        'cbsw-not-allow-edit': !allowEditActivePage(bookingPageViews.BOOKING_SUMMARY_VIEW),
        'cbsw-hide-section': selectedViewPrecedence > showOnePageUiUpToViewPrecedence && selectedViewPrecedence !== sectionPrecedence[bookingPageViews.BOOKING_SUMMARY_VIEW],
        'cbsw-active-section': selectedView === bookingPageViews.BOOKING_SUMMARY_VIEW
      }"
    >
      @if (selectedView === bookingPageViews.BOOKING_SUMMARY_VIEW || showOnePageUI(bookingPageViews.BOOKING_SUMMARY_VIEW)) {
        <app-booking-summary-view
          id="BOOKING_SUMMARY_VIEW"
          (nextPageEvent)="increment(); gotoView($event)"
          (previousPageEvent)="decrement(); gotoView($event)"
          (gotoPageEvent)="gotoView($event)"
          role="region"
          aria-label="Review booking summary"
        />
      }
    </div>

    <div
      id="{{ bookingPageViews.BOOKING_SUCCESS_VIEW }}"
      class="cbsw-booking-success-view"
      role="region"
      [attr.aria-label]="'Booking confirmation'"
      [attr.aria-hidden]="selectedViewPrecedence > showOnePageUiUpToViewPrecedence && selectedViewPrecedence !== sectionPrecedence[bookingPageViews.BOOKING_SUCCESS_VIEW]"
      [ngClass]="{
        'cbsw-not-allow-edit': !allowEditActivePage(bookingPageViews.BOOKING_SUCCESS_VIEW),
        'cbsw-hide-section': selectedViewPrecedence > showOnePageUiUpToViewPrecedence && selectedViewPrecedence !== sectionPrecedence[bookingPageViews.BOOKING_SUCCESS_VIEW],
        'cbsw-active-section': selectedView === bookingPageViews.BOOKING_SUCCESS_VIEW
      }"
    >
      @if (selectedView === bookingPageViews.BOOKING_SUCCESS_VIEW || showOnePageUI(bookingPageViews.BOOKING_SUCCESS_VIEW)) {
        <app-booking-success-view
          id="BOOKING_SUCCESS_VIEW"
          (nextPageEvent)="increment(); gotoView($event)"
          (previousPageEvent)="decrement(); gotoView($event)"
          role="status"
          aria-live="polite"
          aria-label="Booking confirmation details"
        />
      }
    </div>

    <div
      id="{{ bookingPageViews.BOOKING_FAILED_VIEW }}"
      class="cbsw-booking-failed-view"
      role="region"
      [attr.aria-label]="'Booking failed notification'"
      [attr.aria-hidden]="selectedViewPrecedence > showOnePageUiUpToViewPrecedence && selectedViewPrecedence !== sectionPrecedence[bookingPageViews.BOOKING_FAILED_VIEW]"
      [ngClass]="{
        'cbsw-not-allow-edit': !allowEditActivePage(bookingPageViews.BOOKING_FAILED_VIEW),
        'cbsw-hide-section': selectedViewPrecedence > showOnePageUiUpToViewPrecedence && selectedViewPrecedence !== sectionPrecedence[bookingPageViews.BOOKING_FAILED_VIEW],
        'cbsw-active-section': selectedView === bookingPageViews.BOOKING_FAILED_VIEW
      }"
    >
      @if (selectedView === bookingPageViews.BOOKING_FAILED_VIEW || showOnePageUI(bookingPageViews.BOOKING_FAILED_VIEW)) {
        <app-booking-failed-view
          id="BOOKING_FAILED_VIEW"
          (nextPageEvent)="increment(); gotoView($event)"
          role="alert"
          aria-live="assertive"
          aria-label="Booking failed notification"
        />
      }
    </div>
  }
</div>
@if (bookingService?.partnerData?.analytics?.GTM_ENABLED
     && bookingService?.partnerData?.analytics?.GTM
     && bookingService?.partnerData?.analytics?.GTM.trim() !== '') {
  <div aria-hidden="true">
    <app-gtm-operation [gtmID]="bookingService?.partnerData?.analytics?.GTM" />
  </div>
}
